import application from 'application/application';

application

	.directive('ngChar', () => ({
		restrict: 'A',
		link(scope, element, attrs) {

			element.on('keypress', event => {

				let char = String.fromCharCode(event.keyCode);

				if (char.length > 0 && !((new RegExp(`^[${attrs.ngChar}]$`)).test(String.fromCharCode(event.keyCode)))) {

					event.preventDefault();

					$(this).triggerHandler('customEvent');

				}

			});

		}
	}));
